<div class="content-wrapper container-xxl p-0 analytics-page">
  <div class="content-body">
    <section id="ngx-datatable-kitchen-sink">
      <div class="card analytics-summary-card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0" style="font-size: 1rem;">{{ 'MENU.DASHBOARD.analytics' | translate }}</h4>
        </div>

        <div class="card-body">

          <div class="analytics-stats-grid">
          <div class="row g-3">
            <!-- Employees -->
            <div class="col-4 analytics-stat-item">
              <div class="analytics-box d-flex align-items-center p-3 shadow-sm rounded bg-light h-100" (click)="goToEmployees()">
                <div
                  class="analytics-icon text-white rounded-circle d-flex justify-content-center align-items-center me-3"
                  style="width: 60px; height: 60px; background-color: #563825;"
                >
                  <i data-feather="user-check"></i>
                </div>
                <div class="mx-1">
                  <h5 class="mb-0 fw-bolder">{{ 'MENU.DASHBOARD.employees' | translate }}</h5>
                  <h2 class="text-dark mb-0 mt-1 ml-2">{{ employeesCount | number }}</h2>
                </div>
              </div>
            </div>

            <!-- Contracts -->
            <div class="col-4 analytics-stat-item">
              <div class="analytics-box d-flex align-items-center p-3 shadow-sm rounded bg-light h-100" (click)="goToContracts()">
                <div
                  class="analytics-icon text-white rounded-circle d-flex justify-content-center align-items-center me-3"
                  style="width: 60px; height: 60px; background-color: #d2ab66;"
                >
                  <i data-feather="file-text"></i>
                </div>
                <div class="mx-1">
                  <h5 class="mb-0 fw-bolder">{{ 'MENU.DASHBOARD.contracts' | translate }}</h5>
                  <h2 class="text-dark mb-0 mt-1 ml-2">{{ contractsCount | number }}</h2>
                </div>
              </div>
            </div>

            <!-- Investors -->
            <div class="col-4 analytics-stat-item">
              <div class="analytics-box d-flex align-items-center p-3 shadow-sm rounded bg-light h-100" (click)="goToInvisitors()">
                <div
                  class="analytics-icon text-white rounded-circle d-flex justify-content-center align-items-center me-3"
                  style="width: 60px; height: 60px; background-color: #8B5E3C;"
                >
                  <i data-feather="users"></i>
                </div>
                <div class="mx-1">
                  <h5 class="mb-0 fw-bolder">{{ 'MENU.DASHBOARD.investors' | translate }}</h5>
                  <h2 class="text-dark mb-0 mt-1 ml-2">{{ investorsCount | number }}</h2>
                </div>
              </div>
            </div>
          </div>

          <div class="row g-3 mt-3">
            <!-- Partners -->
            <div class="col-4 analytics-stat-item">
              <div class="analytics-box d-flex align-items-center p-3 shadow-sm rounded bg-light h-100" (click)="goToPartners()">
                <div
                  class="analytics-icon text-white rounded-circle d-flex justify-content-center align-items-center me-3"
                  style="width: 60px; height: 60px; background-color: #b58850;"
                >
                  <i data-feather="briefcase"></i>
                </div>
                <div class="mx-1">
                  <h5 class="mb-0 fw-bolder">{{ 'MENU.DASHBOARD.partners' | translate }}</h5>
                  <h2 class="text-dark mb-0 mt-1 ml-2">{{ partnersCount | number }}</h2>
                </div>
              </div>
            </div>

            <!-- Investments -->
            <div class="col-4 analytics-stat-item">
              <div class="analytics-box d-flex align-items-center p-3 shadow-sm rounded bg-light h-100">
                <div
                  class="analytics-icon text-white rounded-circle d-flex justify-content-center align-items-center me-3"
                  style="width: 60px; height: 60px; background-color: #8B5E3C;"
                >
                  <i data-feather="trending-up"></i>
                </div>
                <div class="mx-1">
                  <h5 class="mb-0 fw-bolder">{{ 'MENU.DASHBOARD.investment' | translate }}</h5>
                  <h2 class="text-dark mb-0 mt-1 ml-2">{{ totalInvestment | number }}</h2>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      <!-- Contracts Table Section -->
      <div class="card analytics-payments-card mt-4">
        <div class="card-header analytics-payments-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">{{ 'MENU.DASHBOARD.Upcoming_payments' | translate }}</h4>
          <div class="analytics-header-search">
            <label for="searchInput">{{ 'MENU.DASHBOARD.search' | translate }}</label>
            <input
              id="searchInput"
              type="search"
              [placeholder]="'MENU.DASHBOARD.search' | translate"
              class="form-control form-control-sm"
              (keyup)="filterUpdate($event)"
              (search)="filterUpdate($event)"
            />
          </div>
        </div>
        
        <div class="card-body analytics-payments-body">
          <!-- <p class="card-text mb-4">{{ 'MENU.DASHBOARD.contracts_list' | translate }}</p> -->

          <!-- Corrected ngx-datatable -->
          <ngx-datatable 
            [rows]="contractsData"
            [rowHeight]="58"
            class="bootstrap core-bootstrap bg-white"
            [limit]="itemsPerPage"
            [columnMode]="ColumnMode.force"
            [headerHeight]="40"
            [footerHeight]="72"
            [scrollbarH]="true"
            [messages]="messages">

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-curPage="curPage"
              >
                <div class="analytics-footer-pagination">
                  <datatable-pager
                    *ngIf="rowCount > pageSize"
                    class="analytics-pager"
                    [pagerLeftArrowIcon]="'datatable-icon-left'"
                    [pagerRightArrowIcon]="'datatable-icon-right'"
                    [pagerPreviousIcon]="'datatable-icon-prev'"
                    [pagerNextIcon]="'datatable-icon-skip'"
                    [page]="curPage"
                    [size]="pageSize"
                    [count]="rowCount"
                    (change)="table.onFooterPage($event)">
                  </datatable-pager>

                  <div class="analytics-total-count" dir="rtl">
                    <span>{{ 'MENU.DASHBOARD.total' | translate }}</span>
                    <strong>{{ rowCount }}</strong>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-footer>
            
            <!-- الرقم التسلسلي -->
            <ngx-datatable-column
              name="{{ 'MENU.DASHBOARD.serial_number' | translate }}"
              prop="serial_number"
              [width]="150"
            ></ngx-datatable-column>

            <!-- اسم المستخدم -->
            <ngx-datatable-column
              name="{{ 'MENU.DASHBOARD.user_name' | translate }}"
              prop="user_name"
              [width]="250"
            ></ngx-datatable-column>

            <!-- معرف المستخدم -->
            <!-- <ngx-datatable-column
              name="{{ 'MENU.DASHBOARD.user_id' | translate }}"
              prop="user_id"
              [width]="120"
            ></ngx-datatable-column> -->

            <!-- مبلغ القسط القادم -->
            <ngx-datatable-column
              name="{{ 'MENU.DASHBOARD.next_installment_amount' | translate }}"
              [width]="150"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.next_installment?.amount || '0.00' }} {{ 'MENU.DASHBOARD.Rs' | translate }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Ratio -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.Ratio' | translate }}"
  [width]="180"
>
  <ng-template ngx-datatable-cell-template let-row="row">
    <div *ngIf="row.next_installment" class="w-100">
      <div class="progress" style="height: 8px;">
        <div
          class="progress-bar bg-success"
          role="progressbar"
          [style.width.%]="getInstallmentRatio(row.next_installment)"
        ></div>
      </div>
      <small class="text-muted">
        {{ getInstallmentRatio(row.next_installment) }}%
      </small>
    </div>

    <span *ngIf="!row.next_installment">0%</span>
  </ng-template>
</ngx-datatable-column>


            <!-- تاريخ القسط القادم (ميلادي) -->
            <ngx-datatable-column
              name="{{ 'MENU.DASHBOARD.payment_date' | translate }}"
              [width]="160"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.next_installment?.payment_date || '-' }}
              </ng-template>
            </ngx-datatable-column>

            <!-- تاريخ القسط القادم (هجري) -->
            <ngx-datatable-column
              name="{{ 'MENU.DASHBOARD.payment_date_hijri' | translate }}"
              [width]="190"
            >
        <ng-template ngx-datatable-cell-template let-row="row">
  <div class="hijri-date" *ngIf="row.next_installment?.payment_date_hijri && row.next_installment?.payment_date_hijri !== '-'">
    {{ formatHijriDate(row.next_installment.payment_date_hijri) }}
  </div>
  <span *ngIf="!row.next_installment?.payment_date_hijri || row.next_installment?.payment_date_hijri === '-'">-</span>
</ng-template>
            </ngx-datatable-column>

            <!-- حالة القسط -->
            <ngx-datatable-column
              name="{{ 'MENU.DASHBOARD.status' | translate }}"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <span 
                  class="badge rounded-pill"
                  [ngClass]="{
                    'bg-warning': row.next_installment?.status === 'pending',
                    'bg-success': row.next_installment?.status === 'paid',
                    'bg-danger': row.next_installment?.status === 'overdue'
                  }"
                >
                  {{ row.next_installment?.status_text || '-' }}
                </span>
              </ng-template>
            </ngx-datatable-column>
 <!-- Actions -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group" 
      >
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
      >



  <button 
  class="dropdown-item w-100  d-flex align-items-center justify-content-between"
  ngbDropdownItem
  (click)="addPayment(row.next_installment?.id)"
>
  {{ 'MENU.DASHBOARD.add_payment' | translate }} 
   <i data-feather="eye" class="mr-30 mx-1" ></i>

</button>


  <button 
  class="dropdown-item w-100  d-flex align-items-center justify-content-between"
  ngbDropdownItem
  (click)="openEditDateModal(row)"
>
  {{ 'MENU.DASHBOARD.Edit_Date' | translate }}
   <i data-feather="calendar" class="mr-30 mx-1" ></i>

</button>





          <!-- <button
            class="dropdown-item text-danger w-100  d-flex align-items-center justify-content-between"
            ngbDropdownItem
  (click)="confirmDelete(row.id)"
          >
            {{ 'MENU.DASHBOARD.investor_delete' | translate }}
                        <i data-feather="trash" class="mr-30 mx-1"></i>

          </button> -->
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>





<ng-template #editDateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title fw-bold">
      {{ 'MENU.DASHBOARD.Edit_Date' | translate }}
    </h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      &times;
    </button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label fw-semibold">
        {{ 'MENU.DASHBOARD.payment_date' | translate }}
      </label>

      <input
        type="date"
        class="form-control"
        [(ngModel)]="editPaymentDateValue"
      />
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{ 'MENU.DASHBOARD.Cancel' | translate }}
    </button>

    <button
      class="btn btn-primary"
      (click)="submitEditDate()"
      [disabled]="!editPaymentDateValue"
    >
      {{ 'MENU.DASHBOARD.Confirm' | translate }}
    </button>
  </div>
</ng-template>
